import React from 'react';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { cx } from '@emotion/css';
import { Card, Typography } from '@mui/material';
import useStyles from './BigAlert.styles';
export const BigAlert = ({ className, id, variant, title, description, button, disableIcon = false, iconVariant, }) => {
    const classes = useStyles();
    const variantClassName = variant ? { [variant]: true } : {};
    const iconVariantOverride = iconVariant !== null && iconVariant !== void 0 ? iconVariant : variant;
    const renderIcon = () => {
        switch (iconVariantOverride) {
            case 'success':
                return React.createElement(CheckCircleOutlineRoundedIcon, null);
            case 'error':
                return React.createElement(ErrorOutlineRoundedIcon, null);
            case 'info':
                return React.createElement(InfoOutlinedIcon, null);
            default:
                return React.createElement(WarningAmberRoundedIcon, null);
        }
    };
    return (React.createElement(Card, { variant: "outlined", className: cx(className, classes.content, variantClassName), id: id },
        !disableIcon ? (React.createElement("div", { className: cx(classes.iconWrapper, variantClassName) }, renderIcon())) : null,
        React.createElement("div", { className: cx(classes.bodyWrapper, !disableIcon ? 'isIconShowed' : null) },
            title && (React.createElement(Typography, { className: classes.title, variant: "h3" }, title)),
            description &&
                (typeof description == 'string' ? (React.createElement(Typography, { className: classes.body, variant: "body2" }, description)) : (description)),
            button && (React.createElement("div", { className: cx(classes.buttonWrapper, variantClassName) }, button)))));
};
//# sourceMappingURL=BigAlert.js.map